import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `.app-card {
  border: 1px solid ${dt('surface.200')};
  border-radius: 4px;
  background: ${dt('surface.0')};
  overflow: hidden;
}

.app-card-header {
  border-bottom: 1px solid ${dt('surface.100')};
  padding: ${dt('appCard.header.paddingY')} ${dt('appCard.header.paddingX')};
  font-size: ${dt('appCard.name.fontSize')};
  line-height: ${dt('appCard.name.lineHeight')};
}

.app-card--expanded .app-card-header {
  background: ${dt('appCard.header.background')};
}

.app-card-header span.name {
  color: ${dt('appCard.name.color')};
  font-weight: ${dt('appCard.name.fontWeight')};
  font-size: ${dt('appCard.name.fontSize')};
  line-height: ${dt('appCard.name.lineHeight')};
}

.app-card-header span.meta {
  font-weight: ${dt('appCard.meta.fontWeight')};
  font-size: ${dt('appCard.meta.fontSize')};
  line-height: ${dt('appCard.meta.lineHeight')};
}

.app-card-header span.item-count {
  color: ${dt('appCard.itemCount.color')};
  font-weight: ${dt('appCard.itemCount.fontWeight')};
  font-size: ${dt('appCard.itemCount.fontSize')};
  line-height: ${dt('appCard.itemCount.lineHeight')};
}

.app-card-header span.subtitle {
  color: ${dt('appCard.subtitle.color')};
  font-weight: ${dt('appCard.subtitle.fontWeight')};
  font-size: ${dt('appCard.subtitle.fontSize')};
  line-height: ${dt('appCard.subtitle.lineHeight')};
  margin-top: ${dt('appCard.subtitle.marginTop')};
}

.app-card-body {
  padding: ${dt('appCard.body.paddingTop')} ${dt('appCard.body.paddingX')} ${dt('appCard.body.paddingBottom')};
}

.app-card-body table.p-datatable-table,
.app-card-body table.app-table {
  table-layout: fixed;
}

.app-card-body table.p-datatable-table thead th,
.app-card-body table.app-table thead th {
  background: ${dt('content.background')};
  border-bottom: 1px solid ${dt('surface.200')};
  padding: 0.5rem 0.75rem;
}

.app-card-body table.p-datatable-table tbody td,
.app-card-body table.app-table tbody td {
  border-bottom: 1px solid ${dt('surface.100')};
  padding: 0.5rem 0.75rem;
}

.app-card-body table.p-datatable-table tbody tr:last-child td,
.app-card-body table.app-table tbody tr:last-child td {
  border-bottom: none;
}

.app-card-empty {
  border: 1px dashed ${dt('surface.200')};
  border-radius: 4px;
  padding: 1.5rem;
  text-align: center;
  color: ${dt('surface.500')};
  background: ${dt('surface.0')};
}
`;
